<template>
  <div class="body">
    <Head></Head>
    <div class="head-foot">
		  <img src="../../static/img/products.jpg" width="100%"  alt="">
      <img :src="info.imageBanners" v-if="info.imageBanners" alt="" style="width: 100%;">
      <img src="../../static/img/qiyebanner.jpg" v-else alt="" style="width: 100%;">
      <div id="w-center">
        <div id="Breadcrumb">
          <i class="el-icon-house Breadcrumb-i" ></i>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/Qiyelist' }">企业库</el-breadcrumb-item>
            <el-breadcrumb-item>{{info.title}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="h-30"></div>
        <!-- 左侧开始 -->
        <div  class="left">
          <div class="h-xian"></div>
          <div id="products-right" class="no-products-right">
                <img :src="info.imageLogos" alt="" style="margin: 0 auto;">
                <p class="ProdCont-top-right-title">{{info.title}}</p>
                <p class="xian"></p>
                <p class="ProdCont-top-right-tel center">医疗信息服务客服中心</p>
                <p class="ProdCont-top-right-tel center">{{info.kftel}}</p>
                <p class="xian"></p>
                <p class="ProdCont-top-right-dq">所在地区：{{info.addressdq}}</p>
                <p class="ProdCont-top-right-dq">主营行业：{{info.zyhy}}</p>
          </div>
          <div class="clear h-30"></div>
          <div id="products-right" class="no-products-right" >
               <p class="products-right-title">软件系统</p>
               <ul class="products-right-ul">
                   <li class="ov1">
                        全部（{{count}}）
                   </li>
               </ul>
           </div>
           <div class="clear h-30"></div>
           <div id="products-right" class="no-products-right" >
                <p class="products-right-title">软件系统</p>
                <div class="products-right-ul products-right-ul-lq">
                  <dl>
                    <dt>联系人:</dt>
                    <dd>{{info.lxname}}</dd>
                  </dl>
                  <dl>
                    <dt>电&nbsp;&nbsp;&nbsp;话:</dt>
                    <dd>{{info.kftel}}</dd>
                  </dl>
                  <dl>
                    <dt>传&nbsp;&nbsp;&nbsp;真:</dt>
                    <dd>{{info.cz}}</dd>
                  </dl>
                  <dl>
                    <dt>地&nbsp;&nbsp;&nbsp;址:</dt>
                    <dd>{{info.address}}</dd>
                  </dl>
                  <dl>
                    <dt>邮&nbsp;&nbsp;&nbsp;编:</dt>
                    <dd>{{info.emaile}}</dd>
                  </dl>
                  <dl>
                    <dt>网&nbsp;&nbsp;&nbsp;站:</dt>
                    <dd>{{info.url}}</dd>
                  </dl>
                </div>
            </div>
        </div>
        <div class="w-products rihgt products-content-right-s">
          <div class="h-xian"></div>
          <div class="content">
            <p class="content-jj">企业简介</p>
            <div class="h-10"></div>
            <div class="content-jj-c">{{info.content}}</div>
          </div>
          <div class="h-30"></div>
          <div class="h-xian"></div>
          <div class="content">
            <p class="content-jj">产品库</p>
            <div class="h-10"></div>
            <ul class="jj-cpk-ul">
              <li  v-for="(item, index) in list" :key="item.id">
                <router-link :to="{path:'/ProductsCont',query: {id: item.id}}">
                   <img :src="item.picurl" alt="">
                   <p class="ov2">{{item.title}}</p>
                   <p class="ov1">{{item.money}}</p>
                </router-link>
              </li>
              <div class="clear "></div>
            </ul>
            <div class="page">
              <el-pagination
                background
                layout="prev, pager, next"
                :page-size="10"
                @current-change="handleCurrentChange"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </div>
        <!-- 右侧结束 -->
      </div>
       <Foot></Foot>
  </div>
</div>
</template>

<script>
import foot from '@/components/public/foot.vue'
 import head from '@/components/public/head.vue';
export default{
  data(){
    return {
      list:{},
      page:1,
      total:0,
      info:[],
      id:'',
      count:'',
    }
  },
 
  components: {
     'Foot': foot,
     'Head': head,  //将别名demo 变成 组件 Demo

  },
  mounted () {
    this.id = this.$route.query.id;
    this.recordapi()
  },
  methods:{
   recordapi(){
       var that = this;
       that.$api.post("/Products/CompanyAbout",{'id':that.id,'page':this.page}).then(res => {
         console.log(res);
         that.info= res.info;
         that.list= res.list.data;
         that.total = res.list.total
         that.count= res.count;
       });
   },
   // 分页
   handleCurrentChange(val) {
     console.log(`当前页: ${val}`);
     this.page = val;
     this.recordapi();
   },
  }

 }
</script>



// WEBPACK FOOTER //
// src/components/CompanyAbout.vue